var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_3201_215652)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 11H10C8.89543 11 8 11.8954 8 13V31.5C8 32.6046 8.89543 33.5 10 33.5H34C35.1046 33.5 36 32.6046 36 31.5V13C36 11.8954 35.1046 11 34 11Z",
    fill: "url(#paint1_linear_3201_215652)",
    stroke: "url(#paint2_linear_3201_215652)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.5V19C11 17.8954 11.8954 17 13 17H31C32.1046 17 33 17.8954 33 19V21.5",
    stroke: "url(#paint3_linear_3201_215652)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5V16C11 14.8954 11.8954 14 13 14H31C32.1046 14 33 14.8954 33 16V18.5",
    stroke: "url(#paint4_linear_3201_215652)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2275 25.6679C26.8051 25.0903 27.2441 24.3999 27.5232 23.6486C27.9077 22.6131 28.7704 21.6904 29.875 21.6904H34C35.1046 21.6904 36 22.5859 36 23.6904V31.5004C36 32.6049 35.1046 33.5004 34 33.5004H10C8.89543 33.5004 8 32.6049 8 31.5004V23.6904C8 22.5859 8.89543 21.6904 10 21.6904H14.625C15.7296 21.6904 16.5923 22.6131 16.9768 23.6486C17.2559 24.3999 17.6949 25.0903 18.2725 25.6679C19.3274 26.7228 20.7582 27.3154 22.25 27.3154C23.7418 27.3154 25.1726 26.7228 26.2275 25.6679Z",
    fill: "url(#paint5_linear_3201_215652)",
    stroke: "url(#paint6_linear_3201_215652)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3201_215652",
    x1: 39.16,
    y1: 7.46261e-7,
    x2: -4.36141,
    y2: 19.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3201_215652",
    x1: 9.58076,
    y1: 32.2297,
    x2: 29.0723,
    y2: 7.97361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3201_215652",
    x1: 13.88,
    y1: 11,
    x2: 12.0932,
    y2: 32.5631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3201_215652",
    x1: 15.62,
    y1: 17,
    x2: 15.5285,
    y2: 21.3403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3201_215652",
    x1: 15.62,
    y1: 14,
    x2: 15.5285,
    y2: 18.3403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3201_215652",
    x1: 9.58076,
    y1: 32.8336,
    x2: 17.0836,
    y2: 15.0453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3201_215652",
    x1: 13.88,
    y1: 21.6904,
    x2: 13.3853,
    y2: 33.0648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMenu);
export default __webpack_public_path__ + "static/media/wallet-menu.17ae874d73703758cb21dc136f7ecf7e.svg";
export { ForwardRef as ReactComponent };